import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TopbannerPage } from './topbanner.page';

const routes: Routes = [
  {
    path: '',
    component: TopbannerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TopbannerPageRoutingModule {}
